import { render, staticRenderFns } from "./ActionsBlockRecover.vue?vue&type=template&id=1574b540&scoped=true"
import script from "./ActionsBlockRecover.vue?vue&type=script&lang=js"
export * from "./ActionsBlockRecover.vue?vue&type=script&lang=js"
import style0 from "./ActionsBlockRecover.vue?vue&type=style&index=0&id=1574b540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574b540",
  null
  
)

export default component.exports